import React from 'react';
import { Form } from 'react-bootstrap';
import { utcToday } from '../../utils/utcDateTime';

const Sidebar = ({ filters, onFilterChange }) => {
  const handleSearchChange = e => {
    onFilterChange({ search: e.target.value });
  };

  const handleStartDateChange = e => {
    onFilterChange({ startDate: e.target.value });
  };

  const handleProfileTypeChange = e => {
    const value = e.target.value;
    const updatedTypes = filters.profileTypes.includes(value)
      ? filters.profileTypes.filter(type => type !== value)
      : [...filters.profileTypes, value];
    onFilterChange({ profileTypes: updatedTypes });
  };

  const handleStatusChange = e => {
    const value = e.target.value;
    const updatedStatus = filters.status.includes(value)
      ? filters.status.filter(status => status !== value)
      : [...filters.status, value];
    onFilterChange({ status: updatedStatus });
  };

  const today = utcToday();

  return (
    <div className="profile-filter-bar">
      <Form className="profile-filter-bar-row" aria-label="Filters">
        <Form.Group
          className="profile-filter-field profile-filter-search"
          controlId="profile-search"
        >
          <Form.Label>Search</Form.Label>
          <Form.Control
            type="text"
            placeholder="Search by wallet"
            value={filters.search}
            onChange={handleSearchChange}
          />
        </Form.Group>

        <Form.Group
          className="profile-filter-field profile-filter-date"
          controlId="profile-start-date"
        >
          <Form.Label>Start Date (UTC)</Form.Label>
          <Form.Control
            type="date"
            value={filters.startDate || ''}
            onChange={handleStartDateChange}
            max={today}
          />
          <Form.Text className="text-muted">Show profiles from this UTC date onwards</Form.Text>
        </Form.Group>

        <Form.Group className="profile-filter-field profile-filter-types">
          <Form.Label>Profile Type</Form.Label>
          <div className="profile-filter-checks">
            <Form.Check
              inline
              id="profile-type-primary"
              type="checkbox"
              label="Primary"
              value="primary"
              checked={filters.profileTypes.includes('primary')}
              onChange={handleProfileTypeChange}
            />
            <Form.Check
              inline
              id="profile-type-sub"
              type="checkbox"
              label="Sub"
              value="secondary"
              checked={filters.profileTypes.includes('secondary')}
              onChange={handleProfileTypeChange}
            />
          </div>
        </Form.Group>

        <Form.Group className="profile-filter-field profile-filter-status">
          <Form.Label>Status</Form.Label>
          <div className="profile-filter-checks">
            <Form.Check
              inline
              id="profile-status-completed"
              type="checkbox"
              label="Completed"
              value="COMPLETED"
              checked={filters.status.includes('COMPLETED')}
              onChange={handleStatusChange}
            />
            <Form.Check
              inline
              id="profile-status-needs-review"
              type="checkbox"
              label="Needs Review"
              value="NEEDS_REVIEW"
              checked={filters.status.includes('NEEDS_REVIEW')}
              onChange={handleStatusChange}
            />
            <Form.Check
              inline
              id="profile-status-declined"
              type="checkbox"
              label="Declined"
              value="DECLINED"
              checked={filters.status.includes('DECLINED')}
              onChange={handleStatusChange}
            />
          </div>
        </Form.Group>
      </Form>
    </div>
  );
};

export default Sidebar;
